import './toolbar.sass';

import React, { Component } from 'react';
import { Translate } from 'react-redux-i18n';

export default class Toolbar extends Component {
  render() {
    return (
      <div className='track-statistics-toolbar'>
        <h4><Translate value='trackStatistics.toolbar.aggregatedStatistics'/></h4>
      </div>
    );
  }
}
